import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { TypeEvent } from 'shell/models/type-event';
import { noop } from 'shell/utils/noop';
import TypesEventForm from 'system/components/types-event/form';
import { typesEventCrumbs } from '../constants';
import { transformTypeEvent, transformTypeEventResponse } from '../utils/transform-type-event';

const TypeEventDetailsPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/sistema/eventmanager/tipievento');
  };
  const params = useParams();

  const [typeEvent] = useHttpFetch<HttpResponse<TypeEvent>, transformTypeEventResponse>(
    `${__OPERATION__EVENT__ADMIN__}/tipoEvento/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformTypeEvent,
    }
  );

  return (
    <>
      <Breadcrumbs items={[...typesEventCrumbs, { name: 'Dettaglio Tipo/Evento' }]} />
      <TypesEventForm
        forminitialValues={typeEvent?.data as transformTypeEventResponse}
        title="Dettaglio"
        onOk={noop}
        disabled
        onCancel={onCancel}
      />
    </>
  );
};

TypeEventDetailsPage.displayName = 'Single Type Event Details Page';
export default TypeEventDetailsPage;
